<div class="container-xxl pt-3 d-none d-lg-block">
  <div class="row justify-content-center">
    <div class="col-12 fw-normal text-center text-white-50 text-uppercase">
      <p><span class="material-icons copyright-icons mr-2">copyright</span>2020 Piromax</p>
    </div>
  </div>
</div>
